import {Directive, effect, ElementRef, inject, input, Renderer2} from '@angular/core';
import { IconStatus, statusConfig } from "../../core/models/icon-status-config";

@Directive({
  selector: '[appIconStatus]',
  standalone: true
})
export class IconStatusDirective {
  appIconStatus = input<IconStatus>('DONE')

  private el: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);

  private iconEffect = effect(() => {
    this.appIconStatus() && this.updateIcon();
  });

  private updateIcon(): void {
    const existingIconContainer = this.el.nativeElement.querySelector('.icon-status-container');
    if (existingIconContainer) {
      this.renderer.removeChild(this.el.nativeElement, existingIconContainer);
    }

    const { iconClass, backgroundClass } = statusConfig[this.appIconStatus()];
    const iconContainer = this.createIconContainer(backgroundClass);
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    const icon = this.createIcon(iconClass);

    this.renderer.appendChild(iconContainer, icon);
    this.renderer.appendChild(this.el.nativeElement, iconContainer);
  }

  private createIconContainer(backgroundClass: string): HTMLElement {
    const iconContainer = this.renderer.createElement('div');
    this.renderer.addClass(iconContainer, 'icon-status-container');
    this.renderer.addClass(iconContainer, backgroundClass);

    return iconContainer;
  }

  private createIcon(iconClassName: string): HTMLElement {
    const icon = this.renderer.createElement('i');
    this.renderer.addClass(icon, iconClassName);

    return icon;
  }
}
